module.exports = __webpack_public_path__ + "assets/img/certificated.d576dde3.svg";